/**
 * Use:
 * window.addEventListener("resize", this.update, eventListenerOption.passiveNotCapture);
 * window.removeEventListener("resize", this.update);
 *
 * Based on: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 */
const eventListenerOption = {
	passiveNotCapture:	false as boolean | AddEventListenerOptions,
	passiveCapture:		true as boolean | AddEventListenerOptions
};

try {
	const checker: boolean | AddEventListenerOptions =
		Object.defineProperty(
			{},
			"passive",
			{
				get: function () {
					eventListenerOption.passiveNotCapture = {capture: false, passive: true};
					eventListenerOption.passiveCapture = {capture: true, passive: true};
				}
			}
		);
	const fakeListener = () => {};
	window.addEventListener("test", fakeListener, checker);
	window.removeEventListener("test", fakeListener, checker);
} catch (err) {
}

export default eventListenerOption;